export const TOKENS = {
  Auth: Symbol('Auth'),
  Cart: Symbol('Cart'),
  Catalog: Symbol('Catalog'),
  Checkout: Symbol('Checkout'),
  Cms: Symbol('Cms'),
  CmsMetadata: Symbol('CmsMetadata'),
  CmsRender: Symbol('CmsRender'),
  Consent: Symbol('Consent'),
  CookieConsent: Symbol('CookieConsent'),
  Customer: Symbol('Customer'),
  Download: Symbol('Download'),
  Encryption: Symbol('Encryption'),
  Favorites: Symbol('Favorites'),
  Kco: Symbol('Kco'),
  Lookup: Symbol('Lookup'),
  Loyalty: Symbol('Loyalty'),
  MultiSite: Symbol('MultiSite'),
  Navigation: Symbol('Navigation'),
  Order: Symbol('Order'),
  PreconnectHints: Symbol('PreconnectHints'),
  Recommendations: Symbol('Recommendations'),
  Relation: Symbol('Relation'),
  Review: Symbol('Review'),
  Search: Symbol('Search'),
  Settings: Symbol('Settings'),
  Store: Symbol('Store'),
  Url: Symbol('Url'),
  VippsAuth: Symbol('VippsAuth'),
  VippsPayment: Symbol('VippsPayment'),
  Wishlist: Symbol('Wishlist'),
}
